import { render, staticRenderFns } from "./backHome.vue?vue&type=template&id=125b78cc&scoped=true&"
import script from "./backHome.vue?vue&type=script&lang=js&"
export * from "./backHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125b78cc",
  null
  
)

export default component.exports